import styled from "styled-components"

export const StyledPageNav = styled.div`
  padding: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.darkGrey15};
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey15};
  ${(props) =>
    props.isSticky
      ? `
        background: ${props.theme.colors.white}; 
        position: fixed;
        top: 0;
        z-index: 10;
        left: 0;
        width: 100%;
    `
      : `
        background: ${props.theme.colors.ivory}; 
    `};
`
export const StyledPageNavContainer = styled.div`
  ${(props) => props.theme.mixins.container}
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const StyledPageNavLeft = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
`
export const StyledPageNavShield = styled.div`
  height: 44px;
  display: flex;
  ${(props) =>
    props.isSticky
      ? `
    opacity: 1;
    transition: opacity .2s linear .2s;
    `
      : `
    opacity: 0;
    transition: opacity .2s linear 0s;
    `};

  & img {
    width: 44px;
  }
`
export const StyledPageNavTitle = styled.p`
  margin: 0;
  ${(props) =>
    props.isSticky
      ? `
        transform: translate(8px, 0);
        transition: transform .2s linear .0s;
    `
      : `
      transform: translate(-45px, 0);
      transition: transform .2s linear .2s;
      @media (max-width: ${props.theme.breakPoints.desktop}) {
          transform: translate(-31px, 0);
      }
    `};

  & a {
    font-family: ${(props) => props.theme.fonts.circularBook};
    font-size: 18px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.darkGrey};
  }
`
export const StyledPageNavRight = styled.div`
  display: flex;
`
export const StyledPageNavMenu = styled.nav`
  display: flex;
  margin: 0 -12px;
  position: relative;
  z-index: 1;
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: none;
  }
`
export const StyledPageNavMenuItem = styled.div`
  /* cursor: pointer; */
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;

  & p {
    font-family: ${(props) => props.theme.fonts.circularMedium};
    font-size: 12px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.darkGrey};
    letter-spacing: 1px;
    padding: 12px;
  }
  &:hover {
    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      & p {
        &:after {
          content: "";
          position: absolute;
          bottom: 16px;
          left: 12px;
          width: calc(100% - 24px);
          height: 3px;
          ${(props) =>
            props.pageNavProgram === "bba" &&
            `
              background-color: ${props.theme.colors.undergraduate};
            `}
          ${(props) =>
            props.pageNavProgram === "mba" &&
            `
              background-color: ${props.theme.colors.mba};
            `}
          ${(props) =>
            props.pageNavProgram === "doctorate" &&
            `
              background-color: ${props.theme.colors.doctorate};
            `}
          ${(props) =>
            props.pageNavProgram === "ashridge" &&
            `
              background-color: ${props.theme.colors.executive};
            `}
          ${(props) =>
            props.pageNavProgram === "masters" &&
            `
              background-color: ${props.theme.colors.masters};
            `}
        }
      }
    }

    & div {
      opacity: 1;
      pointer-events: initial;
    }
  }
`
export const StyledPageNavMenuItemGroup = styled.div`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: calc(100%);
  background: ${(props) => props.theme.colors.white};
  left: 0;
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  gap: 16px;
  padding: 16px 0;
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};

  & a {
    ${(props) => props.theme.mixins.body}
    font-family: ${(props) => props.theme.fonts.circularMedium};
    color: ${(props) => props.theme.colors.darkGrey80};

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      &:hover {
        color: ${(props) => props.theme.colors.black};
      }
    }
  }
`
export const StyledPageNavButtons = styled.div`
  margin-left: 24px;
  padding: 16px 0;
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: none;
  }
`
export const StyledPageNavBurger = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: none;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.desktop}) {
    ${(props) =>
      props.isSticky
        ? `
      opacity: 1;
      cursor: pointer;
      transition: opacity .2s linear .2s;
      pointer-events: initial;
  `
        : `
      opacity: 0;
      pointer-events: none;
      transition: opacity .2s linear 0s;
  `};
  }
`

export const StyledPageNavMenuItemGroupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;

  ${(props) =>
    props.dividing_line &&
    `border-bottom: 0.25px solid #B5B5B5;
    padding-bottom: 16px;
    `}
`
export const StyledMainLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  a {
    font-size: 16px;
  }

  & img {
    height: 19px;
  }
`

export const StyledSubHeader = styled.div`
  color: #898988;
  font-size: 14px;
  font-family: ${(props) => props.theme.fonts.circularBook};
`

export const StyledAddOnTracks = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  & a {
    font-size: 14px;
    color: ${(props) => props.theme.colors.darkGrey80};
  }
`

export const StyledAddOnTrackLabel = styled.div`
  display: flex;
  align-items: center;
`

